module.exports = __webpack_public_path__ + "static/media/Rectangle 12884.3a5762b9.png";